export const meta = { id: 'O22', slug: 'criar-formacao', title: 'Como criar uma Formação', description: 'Configure a identidade, objetivo e parâmetros gerais de uma nova Formação.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 520, keywords: ['criar formação','objetivo','público','modalidade','competências'], previous: 'O21', next: 'O23', related: ['O23','O30'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar uma Formação

A criação começa pela identidade do programa antes de montar o currículo.

<HelpImage pendingId="O22.1" alt="Campos gerais de criação de Formação" />

## Informações que podem fazer parte da configuração

- nome ou identidade da Formação;
- objetivo;
- público-alvo;
- modalidade;
- duração ou carga horária, quando configurada;
- resultados esperados;
- Competências relacionadas;
- status.

<Steps>
  <Step title="Crie a Formação">Preencha as informações gerais disponíveis.</Step>
  <Step title="Mantenha em Rascunho durante a montagem">Estruture o currículo antes da publicação.</Step>
  <Step title="Construa Etapas e Componentes">Defina o percurso real do participante.</Step>
  <Step title="Revise regras e resultados">Só então avance para publicação.</Step>
</Steps>
